module.exports = __webpack_public_path__ + "static/button-limitprimaryactions-dont-2df4fd42ccf2ffc82c52c4045fed7fad.png";